import i18n from '../i18n';

export const timePeriods = [
  {
    id: 'last5m',
    name: i18n.t('time.last5m'),
    offset: 5 * 60 * 1000,
    column: 2,
  },
  {
    id: 'last15m',
    name: i18n.t('time.last15m'),
    offset: 15 * 60 * 1000,
    column: 2,
  },
  {
    id: 'last30m',
    name: i18n.t('time.last30m'),
    offset: 30 * 60 * 1000,
    column: 2,
  },
  {
    id: 'last1h',
    name: i18n.t('time.last1h'),
    offset: 1 * 60 * 60 * 1000,
    column: 2,
  },
  {
    id: 'last3h',
    name: i18n.t('time.last3h'),
    offset: 3 * 60 * 60 * 1000,
    column: 2,
  },
  {
    id: 'last6h',
    name: i18n.t('time.last6h'),
    offset: 6 * 60 * 60 * 1000,
    column: 2,
  },
  {
    id: 'last12h',
    name: i18n.t('time.last12h'),
    offset: 12 * 60 * 60 * 1000,
    column: 2,
  },
  {
    id: 'last24h',
    name: i18n.t('time.last24h'),
    offset: 24 * 60 * 60 * 1000,
    column: 2,
  },
  {
    id: 'last3d',
    name: i18n.t('time.last3d'),
    offset: 3 * 24 * 60 * 60 * 1000,
    column: 1,
  },
  {
    id: 'last7d',
    name: i18n.t('time.last7d'),
    offset: 7 * 24 * 60 * 60 * 1000,
    column: 1,
  },
  {
    id: 'last14d',
    name: i18n.t('time.last14d'),
    offset: 14 * 24 * 60 * 60 * 1000,
    column: 1,
  },
  {
    id: 'last30d',
    name: i18n.t('time.last30d'),
    offset: 30 * 24 * 60 * 60 * 1000,
    column: 1,
  },
  {
    id: 'last3months',
    name: i18n.t('time.last3months'),
    offset: 3 * 30 * 24 * 60 * 60 * 1000,
    column: 1,
  },
  {
    id: 'last6months',
    name: i18n.t('time.last6months'),
    offset: 6 * 30 * 24 * 60 * 60 * 1000,
    column: 1,
  },
  {
    id: 'last1year',
    name: i18n.t('time.last1year'),
    offset: 365 * 24 * 60 * 60 * 1000,
    column: 1,
  },
];

export const simpleTimePeriods = [
  {
    id: '5m',
    name: i18n.tc('time.minute', 5),
    offset: 5 * 60 * 1000,
    column: 2,
  },
  {
    id: '15m',
    name: i18n.tc('time.minute', 15),
    offset: 15 * 60 * 1000,
    column: 2,
  },
  {
    id: '30m',
    name: i18n.tc('time.minute', 30),
    offset: 30 * 60 * 1000,
    column: 2,
  },
  {
    id: '1h',
    name: i18n.tc('time.hour', 1),
    offset: 1 * 60 * 60 * 1000,
    column: 2,
  },
  {
    id: '2h',
    name: i18n.tc('time.hour', 2),
    offset: 2 * 60 * 60 * 1000,
    column: 2,
  },
  {
    id: '3h',
    name: i18n.tc('time.hour', 3),
    offset: 3 * 60 * 60 * 1000,
    column: 2,
  },
  {
    id: '4h',
    name: i18n.tc('time.hour', 4),
    offset: 4 * 60 * 60 * 1000,
    column: 2,
  },
  {
    id: '6h',
    name: i18n.tc('time.hour', 6),
    offset: 6 * 60 * 60 * 1000,
    column: 2,
  },
  {
    id: '8h',
    name: i18n.tc('time.hour', 8),
    offset: 8 * 60 * 60 * 1000,
    column: 2,
  },
  {
    id: '12h',
    name: i18n.tc('time.hour', 12),
    offset: 12 * 60 * 60 * 1000,
    column: 2,
  },
  {
    id: '24h',
    name: i18n.tc('time.hour', 24),
    offset: 24 * 60 * 60 * 1000,
    column: 2,
  },
];

export function getTimePeriodById(id) {
  const allPeriods = [...timePeriods, ...simpleTimePeriods];
  for (let i = 0; i < allPeriods.length; i += 1) {
    if (allPeriods[i].id === id) {
      return allPeriods[i];
    }
  }
  return null;
}

export function getTimePeriodByName(name) {
  const timePeriod = timePeriods.find((tp) => tp.name === name);
  return timePeriod || simpleTimePeriods.find((stp) => stp.name === name);
}

export function getTimePeriodByOffset(offset) {
  for (let i = 0; i < timePeriods.length; i += 1) {
    if (timePeriods[i].offset === offset) {
      return timePeriods[i];
    }
  }
  return null;
}

export function displayDateTime(time) {
  let dateTime = time;
  // Convert to a date if its currently a timestamp
  if (!Number.isNaN(time)) {
    dateTime = new Date(time);
  }

  return dateTime.toLocaleString();
}

export function timeAgo(date, anchor = new Date(), showAgo = true) {
  const seconds = Math.floor((anchor - date) / 1000);
  let interval = Math.floor(seconds / 31536000);
  const agoText = showAgo ? 'ago' : '';

  if (interval > 1) {
    return `${interval} years ${agoText}`;
  }

  interval = Math.floor(seconds / 2592000);
  if (interval > 1) {
    return `${interval} months ${agoText}`;
  }

  interval = Math.floor(seconds / 86400);
  if (interval > 1) {
    return `${interval} days ${agoText}`;
  }

  interval = Math.floor(seconds / 3600);
  if (interval > 1) {
    return `${interval} hours ${agoText}`;
  }

  interval = Math.floor(seconds / 60);
  if (interval > 0) {
    return `${interval} minute${interval === 1 ? '' : 's'} ${agoText}`;
  }

  return `less than a minute ${agoText}`;
}
